import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const sessionTypesAdapter = createEntityAdapter({})

const initialState = sessionTypesAdapter.getInitialState()

export const sessionTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSessionTypes: builder.query({
            query: () => ({
                url: '/sessionTypes/getSessionTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedSessionTypes = responseData.map(sessionType => {
                    sessionType.id = sessionType._id
                    return sessionType
                })
                return sessionTypesAdapter.setAll(initialState, loadedSessionTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'SessionType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'SessionType', id}))
                    ]
                } else {
                    return [ { type: 'SessionType', id: 'LIST'}]
                }
            },
        }),
        createNewSessionType: builder.mutation({
            query: initialSessionType => ({
                url: '/sessionTypes/createNewSessionType',
                method: 'POST',
                body: {...initialSessionType,}
            }),
            invalidatesTags: [
                { type: 'SessionType', id: "LIST" }
            ] 
        }),
        updateSessionType: builder.mutation({
            query: initialSessionType => ({
                url: '/sessionTypes/updateSessionType',
                method: 'PATCH',
                body: {...initialSessionType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'SessionType', id: arg.id },
                { type: 'SessionType', id: 'LIST' }
            ],
        }),
        deleteSessionType: builder.mutation({
            query: ({id}) => ({
                url: '/sessionTypes/deleteSessionType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SessionType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetSessionTypesQuery,
    useCreateNewSessionTypeMutation,
    useUpdateSessionTypeMutation,
    useDeleteSessionTypeMutation,
} = sessionTypesApiSlice

// returns the query result object
export const selectSessionTypeResult = sessionTypesApiSlice.endpoints.getSessionTypes.select()

// create memoized selector
const selectSessionTypesData = createSelector(
    selectSessionTypeResult,
    sessionTypeResult => sessionTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllSessionTypes,
    selectById: selectSessionTypeById,
    selectIds: selectSessionTypeIds,
} = sessionTypesAdapter.getSelectors(state => selectSessionTypesData(state) ?? initialState)